export default {
  state: {
    partners: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/PartnersStore.js